module.exports = __webpack_public_path__ + "img/logo_dark.6cd91ff1.svg";